export { default as AllUse } from "./AllUse"
export { default as CookiePolicy } from "./CookiePolicy"
export { default as DataEthics } from "./DataEthics"
export { default as Privacy } from "./Privacy"
export { default as DMCA } from './DMCA'